// Extrae el slug del subdominio actual (ej. "dra-lopez" de
// "dra-lopez.juco.app"). Devuelve null en cualquier otro caso: dominio
// pelado (juco.app), www, localhost, dominios de preview de Vercel
// (*.vercel.app) — el sufijo exacto ".juco.app" ya los excluye a todos
// sin necesitar casos especiales.
export function obtenerSlugDeSubdominio(hostname = window.location.hostname) {
  const sufijo = '.juco.app'
  if (!hostname.endsWith(sufijo)) return null
  const sub = hostname.slice(0, -sufijo.length)
  if (!sub || sub === 'www' || sub.includes('.')) return null
  return sub
}
